import React from 'react';
import { Button } from 'primereact/button';

import { handleRedirection } from 'utils/utils';
import { generateFullName } from 'utils/generateFullNameUtils';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function ExtractEntities() {
  const { caseDetails, isCaseFileManager } = useFileManagerContext();
  const history = useHistory();

  const handleExtractEntities = () => {
    const caseDataToPass = {};
    if (caseDetails?.is_lead) {
      caseDataToPass['main_client_name'] = generateFullName(caseDetails?.main_client[0]);
    } else {
      caseDataToPass['case_name'] = caseDetails?.case_description?.case_name;
    }
    if (caseDataToPass) {
      localStorage.setItem('caseData', JSON.stringify(caseDataToPass));
    }
    const url = `/entities/${isCaseFileManager ? 'cases' : 'leads'}/${caseDetails?.case_id}`;
    handleRedirection(history, url, caseDataToPass);
  };

  return <Button label="Extract Entities" className="p-button-primary outline" onClick={handleExtractEntities} />;
}

export default ExtractEntities;
